<div class="role" [ngClass]="{ closed: isCollapsed }">
  <div class="toggle" aria-controls="collapse">
    <div class="toggle-left" [attr.aria-expanded]="!isCollapsed">
      <img
        [ngClass]="{ chevron: true, open: !isCollapsed }"
        (click)="isCollapsed = !isCollapsed"
        (keydown.enter)="isCollapsed = !isCollapsed"
        tabindex="0"
        src="assets/images/chevron-icon.svg"
        alt="arrow" />
      <div class="checkbox-wrapper">
          <input class="form-check-input lna checkbox" [(ngModel)]="policy.isEnabled" [ngModelOptions]="{ standalone: true }"
            [name]="'policy-' + policy.code" [id]="'policy-' + policy.code" (ngModelChange)="handlePolicyChange()" [disabled]="disabled"
            type="checkbox" />
        <label class="form-label lna" for="holiday">{{ policy.name }}</label>
      </div>
    </div>
  </div>
  <div id="collapseExample" [ngbCollapse]="isCollapsed">
    @for (claim of claims; track claim.code) {
      <div class="item-wrapper">
        <div class="item checkbox-wrapper">
            <input class="form-check-input lna checkbox" [(ngModel)]="claim.isEnabled" [ngModelOptions]="{ standalone: true }"
              [name]="'claim-' + policy.code + '-' + claim.code" [id]="'claim-' + policy.code + '-' + claim.code" [disabled]="disabled"
              (ngModelChange)="handleClaimChange()" type="checkbox" />
          <p class="item-name">{{ claim.name }}</p>
        </div>
      </div>
    }
  </div>
</div>
